import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// api
import { getTextLegalPrivacyNotice } from 'api/company';
// images
import Condiciones from 'assets/img/img_condiciones.png';
// components
import Head from 'components/metatags_helmet/metatags';
import NoResults from 'components/userzone/NoResults';
import './infoPages.scss';

const LegalsAndPrivacy = () => {
  const [legalsAndPrivacy, setLegalAndPrivacy] = useState({});
  const { t, i18n } = useTranslation(['footer']);
  const title = t('legalprivacy');

  const getLegalPrivacy = async () => {
    const { status, data } = await getTextLegalPrivacyNotice();
    if (status === 200) {
      setLegalAndPrivacy(data[0]);
    }
  };

  useEffect(() => {
    getLegalPrivacy();
  }, []);
  return (
    <div className="container-fluid mainDiv">
      <Head title={title} noIndex={true} />
      {legalsAndPrivacy && Object.keys(legalsAndPrivacy).length ? (
        <Row className="justify-content-center mainRow infoRow">
          <Col lg={8} className="mt-4">
            <div className="row">
              <div className="col-md-12">
                <h1 className="infoTitle"> {legalsAndPrivacy[`title_${i18n.language}`] || legalsAndPrivacy.title}</h1>
                <hr />
              </div>
            </div>
            <div className="row">
              <div
                className="col-md-12"
                id="static-content"
                dangerouslySetInnerHTML={{
                  __html: legalsAndPrivacy[`text_${i18n.language}`] || legalsAndPrivacy.text,
                }}
              ></div>
            </div>
          </Col>
          <Col lg={3} className="d-flex justify-content-center align-items-start mt-4 pr-0 pt-lg-4">
            <img src={Condiciones} alt="paper.png" className="infoImg" />
          </Col>
        </Row>
      ) : (
        <NoResults className="noFavorites" />
      )}
    </div>
  );
};

export default LegalsAndPrivacy;
